import React, { useState, useEffect } from 'react';
import AccountApi from '../../api/platform/accountApi';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import styles from '../../css/setting/settings-content.module.css';
import { ResponseErrorModel } from '../../models/system/responseErrorModel';
import { ResponseSuccessModel } from '../../models/system/responseSuccessModel';
import {
  handleError,
  mapResponseErrorToSystemError,
  mapUnknownErrorToSystemError
} from '../../utils/errorUtils';

const LicenseSetting: React.FC = () => {
  const [licenseId, setLicenseId] = useState<string | null>(null);
  const [expirationDate, setExpirationDate] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { triggerSystemError } = useSystemError();

  useEffect(() => {
    const fetchLicenseData = async () => {
      try {
        const response = await AccountApi.getTrialLicense();
        if (response.success) {
          const data = (response as ResponseSuccessModel).data;
          setLicenseId(data.license_id);
          setExpirationDate(data.expiration_date);
        } else {
          handleError(
            mapResponseErrorToSystemError(response as ResponseErrorModel),
            setErrorMessage,
            () => {},
            triggerSystemError
          );
        }
      } catch (error) {
        handleError(
          mapUnknownErrorToSystemError(error, false),
          setErrorMessage,
          () => {},
          triggerSystemError
        );
      } finally {
        setLoading(false);
      }
    };

    fetchLicenseData();
  }, []);

  return (
    <div className={styles.settingsContainer}>
      {loading ? (
        <div className={styles.spinner}>Loading...</div>
      ) : (
        <>
          <div className={styles.formGroup}>
            <label>License ID:</label>
            <div className={styles.formStaticValue}>
              {licenseId || 'N/A'}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label>Expiration Date:</label>
            <div className={styles.formStaticValue}>
              {expirationDate || 'N/A'}
            </div>
          </div>

          {errorMessage && (
            <div className={styles.errorMessage}>{errorMessage}</div>
          )}
        </>
      )}
    </div>
  );
};

export default LicenseSetting;
